package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.RosterFinancialsDto
import com.evoapps.evoshift.domain.model.FinancialSummary
import com.evoapps.evoshift.domain.model.RosterFinancials

class RosterFinancialsMapper(
    private val financialSummaryMapper: FinancialSummaryMapper
) {

    fun toDomain(dto: RosterFinancialsDto): RosterFinancials {
        return RosterFinancials(
            rosterId = dto.rosterId,
            planned = dto.planned?.let { financialSummaryMapper.toDomain(it) } ?: FinancialSummary(0.0, 0.0, 0.0),
            actual = dto.actual?.let { financialSummaryMapper.toDomain(it) } ?: FinancialSummary(0.0, 0.0, 0.0),
            combined = dto.combined?.let { financialSummaryMapper.toDomain(it) } ?: FinancialSummary(0.0, 0.0, 0.0),
            costs = emptyList(),
            days = dto.days,
            daysWithTakings = dto.daysWithTakings
        )
    }

    fun toDto(domain: RosterFinancials): RosterFinancialsDto {
        return RosterFinancialsDto(
            rosterId = domain.rosterId,
            planned = financialSummaryMapper.toDto(domain.planned),
            actual = financialSummaryMapper.toDto(domain.actual),
            combined = financialSummaryMapper.toDto(domain.combined),
            days = domain.days,
            daysWithTakings = domain.daysWithTakings
        )
    }
}
